export const januaryUppercase = "wqa";
export default {januaryUppercase};